<template>
    <span>
        <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
                <v-btn @click="open" color="primary" icon v-bind="attrs" v-on="on">
                    <v-icon >mdi-cloud-download</v-icon>
                </v-btn>
            </template>
            <span>Seleccionar ficheros para desargas</span>
        </v-tooltip>
        
        <app-modal-prompt
            v-model="dialog"
            :title="title"
            :key="dialog"
            @confirm="dialog=false"
            @cancel="dialog=false"
        >
        
        <template #title>
              Documentos disponibles
            </template>
            <div >
              <h3>Documentos para descarga</h3>
              <app-modal-row v-for="documento in lista_documentos">
                <app-modal-col cols="12">
                  <div class="pointer" @click="invoicesFileDownload(documento.uuid)">
                    <v-icon >mdi-file-cloud</v-icon> {{ documento.name }}
                    </div>
                </app-modal-col>
            
              </app-modal-row> 
              
            </div>
            <div >
              <h3>Documentos ya descargados</h3>
              <app-modal-row v-for="documento in lista_documentos_descargados">
                <app-modal-col cols="12">
                  <div class="pointer" @click="invoicesFileDownload(documento.uuid)">
                    <v-icon >mdi-file-check</v-icon> {{ documento.name }} ({{ documento.download_datetime }})
                    </div>
                </app-modal-col>
            
              </app-modal-row> 
              
            </div>  
        </app-modal-prompt>
    </span>
</template>

<script>
import { mapActions } from "vuex";
import { mapFields } from 'vuex-map-fields';
import AppModalPrompt from '@/components/layout/AppModalPrompt.vue';
import DraggableShowHideDialog from './DraggableShowHideDialog.vue';
import AppModalCol from '@/components/layout/AppModalCol.vue';
import AppModalContainer from '@/components/layout/AppModalContainer.vue';
import AppModalRow from '@/components/layout/AppModalRow.vue';
import { string } from "mathjs";
import { client } from "@/api/client";

export default {
    name: 'ShowDownloadInvoicesFilesDialog',
    props: {
        title: {
            type: String,
            default: 'Seleccionar ficheros para descarga'
        },
        read_only:{
            type:Boolean,
            default:false,
        },
        showHideDialog:{
            type: Boolean,
            required: false, 
            default: null,
        },
        currentCompany_id:{
            type:Number,
            default:0,
        }
    },
    data() {
        return {
            dialog: this.showHideDialog || false,
            show: [],
            hide: [],
            lista_documentos: [],
            lista_documentos_descargados: [],
        }
    },
    components: {
        DraggableShowHideDialog,
        AppModalPrompt,
        AppModalCol,
        AppModalRow
    },
    computed: {
        ...mapFields('documents', ['documentListHeaders', 'documentListHiddenHeaders','documentListHeadersReadOnly','documentListHiddenHeadersReadOnly']),
        showHeaders(){
            if(this.read_only){
                return this.documentListHeadersReadOnly
            }
            else{ 
                return this.documentListHeaders
            }
        },
        hiddenHeaders(){
            if(this.read_only){
                return this.documentListHiddenHeadersReadOnly
            }
            else{ 
                return this.documentListHiddenHeaders
            }
        },

    },
    methods:{
        ...mapActions({
            getHeader: "documents/getHeader",
            setHeader: "documents/setHeader",
            setHeaderReadOnly: "documents/setHeaderReadOnly",
        }),

        open() {
            this.dialog = !this.dialog;
            console.log('operacion de open');
            //this.invoicesFileDownload();
            console.log(this.currentCompany_id);
            this.getFilesToDownload();
        },

        getFilesToDownload(){
            //let doc_ids = [ this.currentDocument.id, ];
            let params = {}
            // client.get("facturae/2236418" , params)
            
            client.get(this.currentCompany_id+"/invoicesfiles/" , params)
            .then(response => {
                //let response_json = response.json();
                
                let files_list = response.data['results'];
                
                this.lista_documentos = [];
                this.lista_documentos_descargados = [];
                for(let index in files_list){
                    let documento = files_list[index];
                    
                    if (documento.download_datetime == null){
                        this.lista_documentos.push(documento);
                    }
                    else{
                        this.lista_documentos_descargados.push(documento);
                    }
                }
            
            }).catch(err => {
            //this.message='Algo ha ido mal';
            //this.show_message=true;
            console.error(err);
            });
        },

        invoicesFileDownload(documento_uuid){
        
            //let doc_ids = [ this.currentDocument.id, ];
            let params = {}
            // client.get("facturae/2236418" , params)
            console.log(documento_uuid);
            client.get(this.currentCompany_id+"/invoicesfile/?uuid="+documento_uuid , params)
            .then(response => {
                
                let fileURL = response.data['url'];
                console.log(fileURL);
                if (fileURL == null){
                        console.log('No hay fichero');
                        return;
                    }
                //let fileURL = window.URL.createObjectURL(new Blob([url]));
                let fileLink = document.createElement("a");
            
                fileLink.href = fileURL;
                fileLink.setAttribute("download", "facturae.xlsx");
                document.body.appendChild(fileLink);
            
                fileLink.click();
            
            }).catch(err => {
            //this.message='Algo ha ido mal';
            //this.show_message=true;
                console.error(err);
            });
        },
        updateColumns(data) {
            if(!this.read_only){
                this.documentListHeaders = data['show']
                this.documentListHiddenHeaders = data['hide']
                this.setHeader().then(() => {
                    this.dialog = false;
                }).catch(err => {
                    console.error(err);
                    this.dialog = false;
                });
            }
            else{
                this.documentListHeadersReadOnly = data['show']
                this.documentListHiddenHeadersReadOnly = data['hide']
                this.setHeaderReadOnly().then(() => {
                    this.dialog = false;
                }).catch(err => {
                    console.error(err);
                    this.dialog = false;
                });
            }

        },
        
    },
    mounted(){
        this.getHeader()

    },
}
</script>

<style lang="scss" scoped>
    .primary-bckground {
        background-color: var(--v-primary-base);
    }
    .primary-border {
        border-color: var(--v-primary-base) !important;
    }
    .draggable-item {
        border-style:solid;
        border-right-style:solid;
        border-bottom-style:solid;
        border-color:var(--v-primary-base);
        border-width: thin;
    }
    .text-color {
        color: var(--v-primary-base);
    }


.pointer {
  cursor: pointer;
}

</style>
